export const categoryColorMap: Record<string, string> = {
  announcement: 'blue',
  tip_and_trick: 'cyan',
  feature_release: 'green',
};

export const statusColorMap: Record<string, string> = {
  draft: 'default',
  published: 'success',
};

export const formatCategoryLabel = (value: string): string => {
  if (!value) return '';
  return value
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Converts player.vimeo.com embed URLs to standard vimeo.com URLs
 * so react-player can resolve them via oEmbed.
 */
export const normalizeVimeoUrl = (url: string): string => {
  const match = url.match(/player\.vimeo\.com\/video\/(\d+)/);
  return match ? `https://vimeo.com/${match[1]}` : url;
};

export const getYouTubeId = (url: string): string => {
  const match = url.match(
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([a-zA-Z0-9_-]{11})/
  );
  return match?.[1] ?? '';
};

export const getVimeoId = (url: string): string => {
  const match = url.match(/(?:player\.)?vimeo\.com\/(?:video\/)?(\d+)/);
  return match?.[1] ?? '';
};

export const getVideoThumbnailUrl = (url: string): string | null => {
  const youtubeId = getYouTubeId(url);
  if (youtubeId) return `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;

  const vimeoId = getVimeoId(url);
  if (vimeoId) return `https://vumbnail.com/${vimeoId}.jpg`;

  return null;
};
